import LocationSelect from '@/components/location-select/index.vue';
import UploadImage from '@/components/upload-image/index.vue';
import CoreService from '@/core/core.service.js';
const debounce = require('lodash.debounce');
import { ticketDecrypt } from '@/utils/common.js';
import { fullDate } from '@/filter/index.js';
import regExpObj from '@/utils/regExp.js';
import { mapGetters } from 'vuex';
import LocationService from '@/components/location-select/service';
import getRegion from './get-region';

export default {
  mixins: [getRegion],
  components: {
    LocationSelect,
    UploadImage
  },
  data() {
    const checkFactoryLocations = (rule, value, callback) => {
      if (!value.some(item => item.areaListArr && item.areaListArr.length)) {
        return callback(new Error('请至少选择一个厂区坐落位置'));
      }
      callback();
    };
    return {
      cascaderKey: 1,
      pageType: '',
      companyTypeList: [],
      disabledList: [true, false, false, false, false],
      defaultImageList: [],
      imgUrl: '',
      form: {
        companyName: '',
        socialCreditCode: '',
        areaCode1: '',
        registerAddress: '',
        registerAddress2: '',
        factoryLocations: [],
        legalPersonName: '',
        mobile: '',
        registerCapital: '',
        foundedDate: '',
        businessLicense: '',
        supplementaryContacatName: '',
        supplementaryContacatNumber: ''
      },
      rules: {
        companyName: [
          { required: true, message: '请输入经营主体名称', trigger: 'blur' }
        ],
        socialCreditCode: [
          { required: true, message: '请输入统一社会信用代码', trigger: 'blur' },
          { pattern: regExpObj.socialCreditCode2, message: '请输入18位的统一社会信用代码', trigger: 'blur'}
        ],
        areaCode1: [
          { required: true, message: '请选择所属市（地）', trigger: 'blur' }
        ],
        registerAddress: [
          { required: true, message: '请选择所属县（市、区）', trigger: 'blur' }
        ],
        registerAddress2: [
          { required: true, message: '请输入注册地址', trigger: 'blur' }
        ],
        factoryLocations: [
          { validator: checkFactoryLocations, trigger: 'change' }
        ],
        legalPersonName: [
          { required: true, message: '请输入法人姓名', trigger: 'blur' }
        ],
        mobile: [
          { required: true, message: '请输入法人联系电话', trigger: 'blur' },
          { pattern: regExpObj.phone, message: '请输入正确的手机号', trigger: 'blur'}
        ],
        registerCapital: [
          { required: true, message: '请输入注册资本', trigger: 'blur' }
        ],
        foundedDate: [
          { required: true, message: '请输入成立日期', trigger: 'blur' }
        ],
        businessLicense: [
          { required: true, message: '请上传营业执照', trigger: 'blur' }
        ],
        supplementaryContacatName: [
          { required: true, message: '请输入填报人姓名', trigger: 'blur' }
        ],
        supplementaryContacatNumber: [
          { required: true, message: '请输入填报人联系电话', trigger: 'blur' },
          { pattern: regExpObj.phone, message: '请输入正确的手机号', trigger: 'blur'}
        ]
      },
      loading: false,
      isEdit: true,
      cityList: [],
      districtList: []
    };
  },
  computed: mapGetters([
    'currentAreaCode',
    'businessLicenseImage',
    'businessLicenseInfo',
    'userInfo'
  ]),
  watch: {
    businessLicenseImage: {
      handler (list) {
        this.defaultImageList = list.map(item => {
          const { originame, fullpath } = item;
          return {
            name: originame,
            url: fullpath
          };
        });
        if (list.length) {
          this.form.businessLicense = list[0].url;
          this.imgUrl = list[0].fullpath;
        }
        // console.log(222, this.defaultImageList);
      },
      deep: true,
      immediate: true
    },
    businessLicenseInfo: {
      handler (info) {
        const { name, creditCode, legalPersonName, regLocation, regCapital, estiblishTime } = info;
        if (name) {
          this.form.companyName = name;
          this.form.socialCreditCode = creditCode;
          this.form.legalPersonName = legalPersonName;
          this.form.registerAddress2 = regLocation;
          this.form.registerCapital = regCapital;
          const time = estiblishTime && estiblishTime.match(/\d+/g);
          this.form.foundedDate = time && time.length === 3 && time.join('-') || '';
          // this.form.foundedDate = estiblishTime.replace('年', '-').replace('月', '-').replace('日', '');
        }
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    this.getDictionaryList('CompanyTypeMap');
    this.getLocation(this.currentAreaCode);
  },
  mounted() {
    if (this.$route.path === '/app/edit') {
      this.pageType = 'edit';
      this.getUserInfo();
    } else {
      this.pageType = 'register';
      this.add();
    }
  },
  methods: {
    getDictionaryList(enumName) {
      const params = { enumName };
      CoreService.getDictionaryList(params).then(res => {
        if (enumName === 'CompanyTypeMap') {
          this.companyTypeList = res;
        }
      });
    },
    getLocation (event) {
      this.form.registerAddress = '';
      LocationService.getLocationList(event).then(res => {
        if (res) {
          if (event.length === 2) {
            this.cityList = res.result.filter(item => item.id);
          } else {
            this.districtList = res.result.filter(item => item.id);
          }
        }
      });
    },
    add() {
      this.form.factoryLocations.push({areaListArr: []});
      ++this.cascaderKey;
    },
    deleteArr(index) {
      this.form.factoryLocations.splice(index, 1);
      ++this.cascaderKey;
    },
    getUserInfo() {
      this.$store.dispatch('getUserInfo').then(() => {
        const {
          _id,
          companyName,
          socialCreditCode,
          registerAddress,
          registerAddress2,
          factoryLocations,
          legalPersonName,
          mobile,
          registerCapital,
          foundedDate,
          businessLicense,
          fullBusinessLicense,
          supplementaryContacatName,
          supplementaryContacatNumber,
          isEdit
        } = this.userInfo;
        this.getLocation(registerAddress.slice(0, 4));
        const arr = factoryLocations.map(item => {
          return {
            areaListArr: this.splitCode(2, [], this.getIdLevel(item + ''), item)
          };
        });
        this.form = JSON.parse(JSON.stringify({
          _id,
          companyName,
          socialCreditCode,
          registerAddress,
          areaCode1: registerAddress.slice(0, 4),
          registerAddress2,
          legalPersonName,
          mobile,
          registerCapital,
          foundedDate: fullDate(foundedDate),
          businessLicense,
          supplementaryContacatName,
          supplementaryContacatNumber,
          factoryLocations: arr
        }));
        this.defaultImageList = [{
          name: '营业执照',
          url: fullBusinessLicense
        }];
        this.isEdit = isEdit;
        if (!this.isEdit) {
          this.disabledList = [true, true, true, true, true];
        }
      });
    },
    uploadSuccessImage (list) {
      this.$store.commit('SET_BUSINESS_LICENSE_IMAGE', list);
      console.log(999, list);
      // if (list && list.length) {
      //   const info = {
      //     show: true,
      //     step: 3
      //   };
      //   this.$store.commit('SET_OCR_BOX_INFO', info);
      //   this.getOCRTicket();
      // }
    },
    getOCRTicket() {
      CoreService.getOCRTicket().then(res => {
        const ticketInfo = ticketDecrypt(res);
        this.OCRIdentify(ticketInfo);
      });
    },
    OCRIdentify(ticketInfo) {
      const postData = {
        ...ticketInfo,
        imgUrl: this.imgUrl
      };
      CoreService.OCRIdentify(postData).then(res => {
        this.$store.commit('SET_BUSINESS_LICENSE_INFO', res);
      }).catch((error) => {
        this.$errorMessage(error.data);
        this.$store.commit('SET_BUSINESS_LICENSE_INFO', {});
      }).finally(() => {
        const info = {
          show: false,
          step: 1
        };
        this.$store.commit('SET_OCR_BOX_INFO', info);
      });
    },
    // 验证参数
    checkParams() {
      // const { name, creditCode, legalPersonName } = this.businessLicenseInfo;
      // if (this.form.companyName !== name) {
      //   this.$errorMessage('企业（经营主体）名称和营业执照上信息不一致');
      //   return false;
      // }
      // if (this.form.socialCreditCode !== creditCode) {
      //   this.$errorMessage('统一社会信用代码和营业执照上信息不一致');
      //   return false;
      // }
      // if (this.form.legalPersonName !== legalPersonName) {
      //   this.$errorMessage('法人姓名和营业执照上信息不一致');
      //   return false;
      // }
      return true;
    },
    submit: debounce(function () {
      if (this.loading) {
        return;
      }
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          if (this.checkParams()) {
            const form = JSON.parse(JSON.stringify(this.form));
            form.factoryLocations = form.factoryLocations.map(item => item.areaListArr && item.areaListArr.length && item.areaListArr[item.areaListArr.length - 1]);
            console.log('【form】', this.form, form);
            this.$confirm('确定提交！', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              this.loading = true;
              if (this.form._id) {
                CoreService.editInfo(form).then(({ success }) => {
                  if (success === 'ok') {
                    this.$successMessage('修改成功！');
                    this.$store.dispatch('getUserInfo').then(() => {
                      this.$router.push('/app/index');
                    });
                  }
                }).catch((error) => {
                  this.$errorMessage(error.data && error.data.reason);
                }).finally(() => {
                  this.loading = false;
                });
              } else {
                CoreService.companyRegister(form).then(({ success }) => {
                  if (success === 'ok') {
                    this.$successMessage('注册成功！');
                    this.$router.push('/logon');
                  }
                }).catch((error) => {
                  this.$errorMessage(error.data);
                }).finally(() => {
                  this.loading = false;
                });
              }
            });
          }
        }
      });
    }, 1000, {
      'leading': true,
      'trailing': false
    }),
    // 返回
    cancel () {
      this.$confirm('您确认要取消?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$router.go(-1);
      });
    }
  }
};
